module.exports = __webpack_public_path__ + "static/img/partners_balances.9703272.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/partners_balances.svg
// module id = 6f9e
// module chunks = 1